<mat-card class="events__table-card">
    <div class="events__table-control-filter">
       <div class="table-heading-label"> <h4 class="">Active Events</h4> </div>
        <mat-form-field class="events__table-control">
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
        <mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[10, 20, 50, 100]"
            class="events__table-control paginator">
        </mat-paginator>
    </div>

    <div class="events-table">
        <!-- Creating the Table -->
        <mat-table #table class="ert-table" [dataSource]="dataSource" matSort>

            <!-- Event Description column -->
            <ng-container matColumnDef="metricName">
                <mat-header-cell style="flex: 0 0 20%; padding-right: 15px; justify-content: start;" *matHeaderCellDef mat-sort-header>
                    Event Description
                </mat-header-cell>
                <mat-cell style="flex: 0 0 20%; padding-right: 15px; justify-content: start;" *matCellDef="let event" 
                (click)="(event.siteNo) ? selectSiteMetric(studyId, event.siteId, event.metricId) : selectStudyMetric(studyId, event.metricId)"> 
                    <p *ngIf="!event.siteNo && metricId">{{displayDescription(event.metricName, event.thresholdOperator, event.thresholdValue, event.units)}}</p>
                    <p *ngIf="!metricId"><a>{{displayDescription(event.metricName, event.thresholdOperator, event.thresholdValue, event.units)}}</a></p>
                    <p *ngIf="event.siteNo && metricId"><a>{{displayDescription(event.metricName, event.thresholdOperator, event.thresholdValue, event.units)}}</a></p>
                </mat-cell>
            </ng-container>

            <!-- Site # column -->
            <ng-container matColumnDef="siteNo">
                <mat-header-cell style="flex: 0 0 15%" *matHeaderCellDef mat-sort-header>
                    Site #
                </mat-header-cell>
                <mat-cell style="flex: 0 0 15%" *matCellDef="let event">
                    {{ event.siteNo == null ? 'N/A' : event.siteNo }}
                </mat-cell>
            </ng-container>

            <!-- PI column -->
            <ng-container matColumnDef="pi">
                <mat-header-cell style="flex: 0 0 15%" *matHeaderCellDef mat-sort-header>
                    PI Name
                </mat-header-cell>
                <mat-cell style="flex: 0 0 15%" *matCellDef="let event">
                    {{ event.siteNo == null ? 'N/A' : event.pi}}
                </mat-cell>
            </ng-container>

            <!-- suggested Action column -->
            <ng-container matColumnDef="suggestedAction">
                <mat-header-cell style="flex: 0 0 25%; padding-right: 15px; justify-content: start;" *matHeaderCellDef>
                    Suggested Action
                </mat-header-cell>
                <mat-cell style="flex: 0 0 25%; padding-right: 15px; justify-content: start;" *matCellDef="let event">
                    {{event.suggestedAction}}
                    <ert-no-value *ngIf="!event.suggestedAction"></ert-no-value>
                </mat-cell>
            </ng-container>

            <!-- Category column -->
            <ng-container matColumnDef="category">
                <mat-header-cell style="flex: 0 0 10%; padding-right: 15px; justify-content: start;" *matHeaderCellDef mat-sort-header>
                    Category
                </mat-header-cell>
                <mat-cell style="flex: 0 0 10%; padding-right: 15px; justify-content: start;" *matCellDef="let event">
                    {{thresholdCategory[event.category]}}
                </mat-cell>
            </ng-container>            

            <!-- Study Number column -->
            <ng-container matColumnDef="beginDate">
                <mat-header-cell style="flex: 0 0 15%; padding-right: 15px; justify-content: start;" *matHeaderCellDef mat-sort-header>
                    Event begin Date
                </mat-header-cell>
                <mat-cell style="flex: 0 0 15%; padding-right: 15px; justify-content: start;" *matCellDef="let event"> {{event.beginDate | displayDate}}
                </mat-cell>
            </ng-container>           

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
        <ert-no-data *ngIf="noData" message="No data to display"></ert-no-data>
    </div>
</mat-card>